let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("P1s44")).then(() => parcelRequire('cAGKc'));